/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
 export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
* @param {string} str
* @returns {Boolean}
*/
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}


/**
* 页面变化图表变化
*/
export function resizeFun(chart) {
  setTimeout(function () {
      window.addEventListener("resize", function () {
          chart.resize();
      });
  }, 200);
}

/**
* 数组排序
*/
export function sortBy(field) {
  return (x, y) => {
      return y[field] - x[field];
  };
}

export function getMaxValue(obj) {
  var arr = []
  for (var key in obj) {
      arr.push(obj[key])
  }
  return Math.max(...arr)
}

export function getMaxArr(num, length) {
  var arr = []
  for (var i = 0; i < length; i++) {
      arr.push(num)
  }
  return arr
}

/** 
* echarts字体随屏幕大小自适应
*/
export function fontchange(res) {
  let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (!clientWidth) return;
  let fontSize = 100 * (clientWidth / 1920);
  return res * fontSize;
}
